export enum InviteStatus {
  Invited = 'INVITED',
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED'
}
